module.exports = __webpack_public_path__ + "img/toolmanagement.b598baff.png";